import React, { createContext, useContext } from 'react'

interface FilterSectionContextValue {
  expandedSections: Set<string> | null
  scrollToSection: string | null
  onScrollComplete: () => void
  highlightField: string | null
  onHighlightComplete: () => void
}

const defaultValue: FilterSectionContextValue = {
  expandedSections: null,
  scrollToSection: null,
  onScrollComplete: () => {},
  highlightField: null,
  onHighlightComplete: () => {},
}

const FilterSectionContext =
  createContext<FilterSectionContextValue>(defaultValue)

export const useFilterSectionContext = () => useContext(FilterSectionContext)

interface FilterSectionProviderProps {
  expandedSections: Set<string> | null
  scrollToSection: string | null
  onScrollComplete: () => void
  highlightField?: string | null
  onHighlightComplete?: () => void
  children: React.ReactNode
}

export const FilterSectionProvider: React.FC<FilterSectionProviderProps> = ({
  expandedSections,
  scrollToSection,
  onScrollComplete,
  highlightField = null,
  onHighlightComplete = () => {},
  children,
}) => {
  const value = React.useMemo(
    () => ({
      expandedSections,
      scrollToSection,
      onScrollComplete,
      highlightField,
      onHighlightComplete,
    }),
    [
      expandedSections,
      scrollToSection,
      onScrollComplete,
      highlightField,
      onHighlightComplete,
    ]
  )

  return (
    <FilterSectionContext.Provider value={value}>
      {children}
    </FilterSectionContext.Provider>
  )
}
